module.exports = __webpack_public_path__ + "img/gateway_d.18f50eec.svg";